import React, { memo, PropsWithChildren, useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { CMS_BASE_URL, SPA_BASE_URL } from '@/utils/constants';
import { Props } from './GlobalFooter.interface';

type GlobalFooterProps = Props;

const GlobalFooter = (props: PropsWithChildren<GlobalFooterProps>) => {
  const { children, categories, config, labels, datalayerVariant } = props;
  const globalFooterRef = useRef<any>();
  const history = useHistory();

  const openOnetrustCookieSettingModal = useCallback(() => {
    if ((window as any).OneTrust) {
      (window as any).OneTrust.ToggleInfoDisplay();
    }
  }, []);

  useEffect(() => {
    const handleNavigate = (e: CustomEvent) => {
      const { href } = e.detail;
      history.push(href);
    };

    if (globalFooterRef) {
      globalFooterRef.current.addEventListener('navigate', handleNavigate);
      globalFooterRef.current.addEventListener(
        'onCookieSettingClick',
        openOnetrustCookieSettingModal,
      );
    }
  }, [globalFooterRef, history, openOnetrustCookieSettingModal]);

  useEffect(() => {
    const handleOpenLivechat = () => {
      if (!window.LC_API) {
        return;
      }

      window.LC_API.open_chat_window();
    };

    if (globalFooterRef) {
      globalFooterRef.current.addEventListener('openLivechat', handleOpenLivechat);
    }
  }, [globalFooterRef]);

  return (
    <div data-testid="qa-globalFooter">
      <gntc-global-footer
        cmsBaseUrl={CMS_BASE_URL}
        spabaseurl={SPA_BASE_URL}
        categories={JSON.stringify(categories)}
        config={JSON.stringify(config)}
        labels={JSON.stringify(labels)}
        ref={globalFooterRef}
        datalayerVariant={datalayerVariant}
      >
        {children}
      </gntc-global-footer>
    </div>
  );
};

export default memo(GlobalFooter);

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'gntc-global-footer': any;
    }
  }
  interface Window {
    LC_API: any;
  }
}
